module.exports = __webpack_public_path__ + "img/11.99d9f792.png";